import { render, staticRenderFns } from "./icon-italic.vue?vue&type=template&id=2196e15e"
import script from "./icon-italic.vue?vue&type=script&lang=js"
export * from "./icon-italic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports